<template lang="pug">
b-modal#addDomainBatch(
  ref="addDomainBatch"
  :title="$t('ui.combine.add_domain_batch')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.domain_list')")
      b-form-textarea(
        ref="domain_list"
        size="sm"
        required
        :dirty="$v.domain_list.$dirty"
        :error="$v.domain_list.$error"
        v-model.trim.lazy="$v.domain_list.$model"
        rows="10"
        max-rows="10"
        trim=true
        :disabled="loading"
        @paste="handlePaste"
      )
    ValidateResult(:value="$v.domain_list" :name="$t('ui.domain_list')")
    b-form-group(:label="$t('ui.module')" disabled).mb-0
      ModuleLookup(
        size="sm"
        ref="module"
        required
        type="array"
        :dirty="$v.module.$dirty"
        :error="$v.module.$error"
        v-model.trim.lazy="$v.module.$model"
        :hideOpt="hideOpt"
        :disabled="loading"
      )
      ValidateResult(:value="$v.module" :name="$t('ui.module')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import ModuleLookup from "@/library/ModuleLookup";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    ModuleLookup
  },
  props: {
    // item: {
    //   type: Object
    // },
  },
  data() {
    return {
      hideOpt: ['OPERATOR'],
      domain_list: "",
      module: "MEMBER",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
  },
  validations: {
    domain_list: {
      required,
    },
    module: {
      required,
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();  
    },
    handlePaste(event) {
      event.preventDefault(); // Prevent the default paste action

      // // Get the pasted data from the clipboard
      let pastedData = event.clipboardData.getData('Text');

      // Remove newline characters from the pasted data
      pastedData = pastedData.replace(/\n/g, ' ');

      // Split the pasted data into an array by whitespace characters
      let dataArray = pastedData.split(' ');

      // Remove the first row if it is "ID"
      if (dataArray[0].trim() === 'ID') {
        dataArray.shift();
      }

      // Filter out any empty strings in the array
      dataArray = dataArray.map(item => item.trim()).filter(item => item !== '');

      // Join the array into a comma-separated string
      const commaSeparatedData = dataArray.join(', ');

      // Set the text area content to the comma-separated string
      this.domain_list = commaSeparatedData;
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.domainDefaultAddBatchUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          domain_list: this.domain_list,
          module: this.module
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", response.data);
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_domain_batch", this.feedback.status);
                }
                this.$refs.addDomainBatch.hide();
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.domain_list = "";
      this.module = "";
    },
    shown: function() {
      this.$v.$reset();
      this.module = "MEMBER";
      this.$refs.domain_list.$el.focus();
    }
  }
};
</script>
